import React, { useEffect } from "react";
import { APP_FONT_STACK, logType, useJourney } from "../utils/common";
import { useAppContext } from "../AppContextDef";
import useIsMobile from "../utils/useIsMobile";
import { useTranslation } from "react-i18next";
import { usePubSub } from "@videosdk.live/react-sdk";
import useIsTab from "../utils/useIsTab";
import usePubsubFunction from "../utils/usePubsubFunction";

const DisagreePage = ({ setCurrentPage, isPubSubPage = false }) => {
  const { logJourney } = useJourney();
  const { applicationNo, selectedLang, allPubsubData } =
    useAppContext();
  const { publish: publishCurrentPage } = usePubSub(`CURRENT_PAGE`);
  const pubsubPublishMethod = usePubsubFunction()

  let isMobile = useIsMobile();
  let isTab = useIsTab();
  let isMobileOrTab = isMobile || isTab
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  useEffect(() => {
    changeLanguage(selectedLang?.lang);
  }, [selectedLang]);

  useEffect(() => {
    pubsubPublishMethod(publishCurrentPage, "Page", { persist: true }, { message: "Disagree" });
    if (!isPubSubPage) {
      logJourney({
        type: logType.NAVIGATION,
        message: "Navigated to Disagree Page",
      });
    }
  }, []);

  const fontFamilyCSS = APP_FONT_STACK;

  let appNo = applicationNo ? applicationNo : allPubsubData?.applicationNo;


  return (
    <div
      className="py-3 px-3 lg:py-10 lg:px-8 xl:px-14 w-full max-h-screen lg:h-full"
    >
      <div
        style={{
          backgroundImage:
            !isMobileOrTab &&
            "linear-gradient(360deg, rgba(107, 107, 184, 0) 81.6%, rgba(107, 107, 184, 0.1) 100%)",
        }}
        className="flex flex-1 flex-col h-full justify-center items-center lg:border lg:border-gray-275 lg:rounded-xl lg:py-10"
      >
        <div className="w-full mt-0 flex flex-col items-center justify-center">
          <div className="bg-[#FFF2ED] rounded py-2 px-3 mb-5 max-w-max">
            <p style={{ fontFamily: fontFamilyCSS }} className="text-orange-150 text-sm font-semibold mb-0">
              {`${t(`Application number`)}: ${appNo}`}
            </p>
          </div>

          <div>
            <div className="text-center text-sm lg:text-lg text-gray-150">
              <p style={{ fontFamily: fontFamilyCSS }} className="text-center text-base lg:text-lg text-gray-150">
                {t(
                  `Thank you for your response. Our representative will contact you soon.`
                )}
              </p>
            </div>
          </div>

          <div className="mt-10">
            <button
              onClick={() => {
                // setCurrentPage("Intro");
                window.location.reload();
              }}
              style={{ fontFamily: fontFamilyCSS }}
              className="bg-orange-150 px-3 py-2 lg:p-3 rounded-md text-base lg:text-lg font-bold mb-0 text-white"
            >
              {t("Return to homepage")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );

};

export default DisagreePage;
